export const COMPANY_BRANCH = Object.freeze({
  ALL: "All",
  BRITANNIA: "Britannia Crossing",
  INTERNATIONAL: "International Avenue",
  EDMONTON: "Edmonton",
  RED_DEER: "Red Deer",
  LETHBRIDGE: "Lethbridge",
  REMOTE: "Remote",
  TEST: "Test Branch",
});